<template>
    <div class="row">
        <div class="col-12">
          <div class="card-header-actions">
            <div class="col-12 justify-content-md-end mt-md-0 mt-2 card-header-btns-box">
              <button class="all-btn add-btn m-0" @click="showEmploymentCoefficientModal(null)">{{$t("action.add")}}</button>
            </div>
          </div>
        </div>
        <div class="col-12">
            <div class="table-wrapper">
              <table class="table table-hover">
                  <thead>
                      <tr>
                          <th>#</th>
                          <th>Вилоят</th>
                          <th>Референс</th>
                          <th>Актив</th>
                          <th>Киритилган сана</th>
                          <th>Яратган фойдаланувчи</th>
                          <th class="text-center">{{$t("realEstate.field.action")}}</th>
                      </tr>
                  </thead>
                  <tbody v-if="!loading && results && results.data">
                      <tr v-for="result in results.data" :key="result.id">
                          <td>{{result.id}}</td>
                          <td>{{result.province.name}}</td>
                          <td>{{result.coefficientField.name}}</td>
                          <td>{{result.visibleState}}</td>
                          <td>{{new Date(result.createdDate) | dateFormat('DD/MM/YYYY HH:mm')}}</td>
                          <td>{{result.createdBy.name}}</td>
                          <td class="td-actions text-center">
                              <button class="all-btn edit-btn table-action" data-original-title="Edit" @click="showEmploymentCoefficientModal(result)">
                                  <i class="fa fa-edit"></i>
                              </button>
                          </td>
                      </tr>
                  </tbody>
              </table>
            </div>
            <div class="text-center">
                <div class="loader mt-5 mb-5" v-if="loading"></div>
                <span class="no-data mt-5 mb-5" v-if="!loading && results && results.data && results.data.length===0">{{$t("messages.list.empty")}}</span>
            </div>
            <div class="row" v-if="!loading && results && results.total && results.total > 1 ">
                <div class="col-12 pt-3 pb-3">
                    <b-pagination :total-rows="results.total" v-model="filter.page.page" :per-page="filter.page.size" @change="onPageChange">
                    </b-pagination>
                </div>
            </div>
        </div>
            <RealEstateEmploymentCoefficientEditModal />
    </div>
</template>

<script>
    import initFilterModel from '@/shared/filter';
    import RealEstateEmploymentCoefficientEditModal from './RealEstateEmploymentCoefficientEditModal'
    import bPagination from 'bootstrap-vue/es/components/pagination/pagination';

    export default {
        components: {
            RealEstateEmploymentCoefficientEditModal,
            'b-pagination': bPagination
        },
        data() {
            return {
                loading: false,
                filter: initFilterModel(),
                results: null
            }
        },
        methods: {
            initList() {
                this.loading = true;
                this.$http.post('real-estate/employment/coefficient/list',this.filter)
                    .then(res => {
                        this.results = res.data;
                        console.log(res.data);
                        this.loading = false;
                    },err => {
                        this.loading = false;
                        console.log(err)
                    });
            },
            showEmploymentCoefficientModal(data) {
                this.$eventBus.$emit('showEmploymentCoefficientModal',data)
            },
            onPageChange(page) {
                this.filter.page.page = page;
                this.initList();
            }
        },
        created() {
            this.initList();
            this.$eventBus.$on('employmentCoefficientChange', () => {
                this.initList();
            });
        }
    }
</script>

<style scoped>

</style>